import React from "react";

import axios from "axios";
import { Grid } from "@material-ui/core";
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import DoneIcon from '@mui/icons-material/Done';
import UploadIcon from '@mui/icons-material/Upload';
import TextField from '@mui/material/TextField';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import CancelIcon from '@mui/icons-material/Cancel';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import Checkbox from '@mui/material/Checkbox';

import * as Constants from "../../../../consts/Constants.js";
import NoticePreview from "./notice-preview"

import { Notice } from '../../../../plas/services/notices/models';
import service from '../../../../plas/services/notices/service';
import alerter from "../../../alerts/alerter"
import { createByteArray } from "../../../../plas/utils";



export default function NoticeForm({
	initialNotice,
	onCancel,
	onSave,
	fullWidth
}) {

	const theme = createTheme({
	  palette: {
	    primary: {
	      main: '#FFFFFF',
	      darker: '#FFFFFF',
	    }
	  },
	});

	const [notice] = React.useState(initialNotice ? initialNotice : new Notice());
	const [categories, setCategories] = React.useState([]);
	const [loadingCategories, setLoadingCategories] = React.useState(false);
	const [selectedCategory, setSelectedCategory] = React.useState(null);
	const [selectedSubCategory, setSelectedSubCategory] = React.useState(null);

	const [title, setTitle] = React.useState(initialNotice ? initialNotice.title : null);
	const [body, setBody] = React.useState(initialNotice ? initialNotice.body : null);
	const [url, setUrl] = React.useState(initialNotice? initialNotice.url : null);
	const [alert, setAlert] = React.useState(false);

	const inputFile = React.useRef(null)
	const [imageBlob, setImageBlob] = React.useState(null);

	const [saving, setSaving] = React.useState(false);
	const [canSave, setCanSave] = React.useState(false);

	React.useEffect(() => {
		loadCategories();
		if (notice.id) {
			loadImage()
		}
	}, []);

	const prepareCategories = (data) => {
		data.forEach((item) => {
			item.label = item.name;
			item.subCategories.forEach((subItem) => {
				subItem.label = subItem.name;
			});
			item.subCategories.unshift({label: 'General', id: -1})
		})
		setCategories(data);
	}

	const loadCategories = (placeCategory) => {
		setLoadingCategories(true);
		service.api.categories.get(false, (response) => {
	        if (response.error != null) {
        		alerter.showError(response.error);
        		if (onCancel)
        			onCancel()
			} else {
				prepareCategories(response.result);
				setLoadingCategories(false);
			}
    	});
	}

	const saveHandler = () => {
		if (notice.id) {	
			update()
		} else {
			create();
		}
	}

	const loadImage = () => {
	    axios.get(service.api.notices.getMediaUrl(notice.id, notice.binId), { responseType: 'blob' }).then((response) => {
	        let blob = response.data;
	        let newBlobUrl = URL.createObjectURL(blob);
	        setImageBlob(newBlobUrl);
	      }
	    );
	}

  	const create = () => {
  		setSaving(true)
  		service.api.notices.create(notice, (response) => {
  			if (response.result != null) {
  				if (onSave)
  					onSave(response.result);
  			} else {
  				alerter.showError(response.error);
  			}
			setSaving(false)
		});
	}

	const update = () => {
  		// TODO
	}

	const selectCategory = (newCategory) => {
		notice.categoryId = newCategory.id;
		setSelectedCategory(newCategory);
		setCanSave(notice.isValid());
	}

	const selectSubCategory = (newCategory) => {
		if (newCategory.id !== -1)
			notice.categoryId = newCategory.id;
		setSelectedSubCategory(newCategory);
		setCanSave(notice.isValid());
	}

	const imageButtonClick = () => {
	    inputFile.current.click();
	}

	const removeImageButtonClick = () => {
		notice.binId = null;
		notice.attachedBin = null;
		setImageBlob(null);
		setCanSave(notice.isValid());
	}

  	const onSelectFile = (event) => {
	    event.stopPropagation();
	    event.preventDefault();

	    var file = event.target.files[0];

	    if (file) {
			let url = URL.createObjectURL(file);
			notice.attachedBin = {
					name: file.name,
					type: file.type,
					data: createByteArray(url)
			}
			setImageBlob(url);
			setCanSave(notice.isValid());
	    }
	}

	const onChangeBody = (e) => {
		let value = e.target.value.trim();
		notice.body = value ? value : null;
		setBody(e.target.value);
		setCanSave(notice.isValid());
	}

	const onChangeTitle = (e) => {
		let value = e.target.value.trim();
		notice.title = value ? value : null;
		setTitle(e.target.value);
		setCanSave(notice.isValid());
	}

	const onChangeUrl = (e) => {
		let value = e.target.value.trim();
		notice.url = value ? value : null;
		setUrl(e.target.value);
		setCanSave(notice.isValid());
	}

	const onChangeAlert = (e) => {
		notice.alert = e.target.checked;
		setAlert(notice.alert);
		setCanSave(notice.isValid());
	}

	const ColoredLine = ({ color }) => (
	    <hr
	        style={{
	            color: color,
	            backgroundColor: color,
	            marginTop: 6,
	            marginBottom: 16,
	            height: 2
	        }}
	    />
	);

	return(
 		<Grid container>
 			<Grid item xs={12} style={{ textAlign: "center"}}>
	   		{ loadingCategories ?
	        (
	            <CircularProgress style={{color:Constants.COLOR_PRIMARY}} color="inherit" />
	        ) :
	        (<Grid container spacing={2}>
		 		<Grid item xs={false} md={ fullWidth ? false : 2} />
		       	<Grid item xs={12} md={ fullWidth ? 12 : 8} >
		       		<Grid container spacing={2}>
		       			<Grid item xs={12}>
							<p style={{ fontSize: '28px', textAlign: 'left'}}>
								Datos de la noticia
							</p>
							<ColoredLine color="gray"/>
							<Grid container spacing={2}>
								<Grid item xs={12} md={true}>
				       				<Grid container spacing={2}>
										<Grid item xs={6}>
											<Autocomplete
												disabled={!categories || saving}
												options={categories? categories : []}
												renderInput={(params) => 
													<TextField 
														{...params}
														required  
														label="Categoría" 
													/>}
												value={selectedCategory}
												onChange={ (event, newValue) => selectCategory(newValue)}
											/>
										</Grid>
										<Grid item xs={6}>
											<Autocomplete
												disabled={!categories || saving || !selectedCategory}
												options={selectedCategory? selectedCategory.subCategories : []}
												renderInput={(params) => 
													<TextField 
														{...params}
														required  
														label="Subcategoría" 
													/>}
												value={selectedSubCategory}
												onChange={ (event, newValue) => selectSubCategory(newValue)}
											/>
										</Grid>
										<Grid item xs={12}>
											<TextField
												required
												variant="outlined"
												id="name"
												label="Titulo"
												name="title"
												onChange={onChangeTitle}
												disabled={saving}
												value={title}
												fullWidth
												placeholder="Titulo"/>
										</Grid>
										<Grid item xs={12}>
											<TextField
												variant="outlined"
												id="body"
												required
												disabled={saving}
												label="Descripción"
												name="body"
												multiline
												minRows={3}
												maxRows={6}
												value={body}
												onChange={onChangeBody}
												fullWidth
												placeholder="Descripción del aviso o evento..."/>
										</Grid>
										<Grid item>
											<Box
											  display="flex"
											  justifyContent="center"
											  alignItems="center"
											  height="100%">
												¿Es una alerta?
												<Checkbox 
													checked={alert}
													onChange={onChangeAlert} />
											</Box>
										</Grid>
										<Grid item xs={true}/>
										<Grid item>
											{ !notice.binId && !imageBlob ? (
											<ThemeProvider theme={theme}>
												<Button
													disabled={saving}
													startIcon={<UploadIcon/>}
													variant="contained"
													onClick={imageButtonClick}>
													<input type='file' accept="image/*" id='file' ref={inputFile} style={{display: 'none'}} onChange={onSelectFile}/>
													Cargar imagen
												</Button>
											</ThemeProvider>) : (
											<ThemeProvider theme={theme}>
												<Button
													disabled={saving}
													startIcon={<DeleteOutlineIcon/>}
													variant="contained"
													onClick={removeImageButtonClick}>
													Borrar imagen
												</Button>
											</ThemeProvider>
											)}
										</Grid>
										<Grid item xs={12}>
											<TextField
												variant="outlined"
												id="url"
												disabled={saving}
												label="URL"
												name="url"
												value={url}
												onChange={onChangeUrl}
												fullWidth
												placeholder="Link a mas información..."/>
										</Grid>
					             	</Grid>
				       			</Grid>
				       			<Grid item xs={12} md={'auto'}>
									<Box
									  display="flex"
									  justifyContent="center"
									  alignItems="center"
									  height="100%">
										<NoticePreview 
											title={title}
											body={body}
											url={url}
											image={imageBlob}
											category={selectedCategory}
											subCategory={selectedSubCategory}
											loadingImage={notice.binId && !imageBlob}
										/>
									</Box>
								</Grid>
							</Grid>
						</Grid>
						{ onCancel || onSave ? (
							<Grid item xs={12}>
								<ColoredLine color="gray"/>
								<Grid container spacing={2}>
									<Grid item xs={true}/>
									<Grid item>
										{ onCancel? (
											<ThemeProvider theme={theme}>
												<Button 
									            	disabled={saving} 
									            	startIcon={<CancelIcon/>} 
									            	variant="contained" 
									            	onClick={() => onCancel()}>
									            	Cancelar
									            </Button>
									        </ThemeProvider>) : (null)
								        }
									</Grid>
									<Grid item>
										{ onSave ? (
											<LoadingButton
												disabled={!canSave}
									            loadingPosition="start"
									            startIcon={<DoneIcon />}
									            loading={saving}
									            variant="contained"
									            onClick={saveHandler}>
									            <b>{ notice.id ? "Actualizar" : "Enviar" }</b>
							          		</LoadingButton>) : (null)
						          		}
									</Grid>
								</Grid>
							</Grid>) : (null)
						}
		       		</Grid>
	           	</Grid>
	       		<Grid item xs={false} md={ fullWidth ? false : 2} />
	  		</Grid>
	  		)}
			</Grid>
		</Grid>
	)

}
